import { ConcreteEncodable } from "./ConcreteEncodable";

import { CounterPartyDetailsImplEncoder } from "../../encoder/CounterPartyDetailsImplEncoder";

import * as CubiqTS from "../../index";
import { CounterPartyDetails } from "../CounterPartyDetails";

export class CounterPartyDetailsImpl extends ConcreteEncodable implements CounterPartyDetails {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.CounterPartyDetailsImpl";

  /*FID=1*/
  public account: CubiqTS.Account | null = null;
  /*FID=2*/
  public client: CubiqTS.Client | null = null;
  /*FID=3*/
  public contacts: Array<CubiqTS.ClientContact> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = CounterPartyDetailsImplEncoder.Instance;
    this.setEncodableType(CounterPartyDetailsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "CounterPartyDetailsImpl[" +
      "account=" +
      this.account +
      "client=" +
      this.client +
      "contacts=" +
      this.contacts +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
